/* eslint-disable import/no-cycle */
/* eslint-disable no-return-assign */
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    navigation_menu: [],
  },
  getters: {
    getNavigationMenu: state => state.navigation_menu,
  },
  mutations: {
    setNavigationMenu: (state, value) => (value ? (state.navigation_menu = value) : (state.navigation_menu = [])),
  },
  actions: {
    dataNavigationMenu({ commit, rootState }) {
      const dataTelco = [
        {
          title: 'Dashboard',
          route: 'dashboard',
          icon: 'LayersIcon',
        },
        {
          title: 'Campaign',
          icon: 'HashIcon',
          children: [
            {
              title: 'Manage Campaign',
              route: 'manage-campaign',
            },
            {
              title: 'Create Campaign',
              route: 'create-campaign',
            },
            // {
            //   title: 'Approve Campaign',
            //   route: 'approve-campaign',
            // },
          ],
        },
        {
          title: 'Report',
          route: 'report',
          icon: 'ActivityIcon',
        },
        // {
        //   title: 'Auction',
        //   icon: 'ClockIcon',
        //   children: [
        //     {
        //       title: 'Open Auction',
        //       route: 'open-auction',
        //     },
        //     {
        //       title: 'Auction Won',
        //       route: 'auction-won',
        //     },
        //     {
        //       title: 'History',
        //       route: 'history',
        //     },
        //   ],
        // },
        // {
        //   title: 'Rate Card',
        //   route: 'rate-card',
        //   icon: 'GridIcon',
        // },
        {
          title: 'Finance',
          icon: 'CreditCardIcon',
          children: [
            {
              title: 'Invoice',
              route: 'invoice',
            },
            // {
            //   title: 'Topup Credit',
            //   route: 'topup-credit',
            // },
          ],
        },
        // {
        //   title: 'Domain',
        //   route: 'domain',
        //   icon: 'GlobeIcon',
        // },
        // {
        //   title: 'Inbox',
        //   route: 'inbox',
        //   icon: 'InboxIcon',
        // },
        {
          title: 'Account',
          icon: 'UsersIcon',
          children: [
            {
              title: 'New Partner Approval',
              route: 'account-approval',
            },
            {
              title: 'Partner Listings',
              route: 'account-partner',
            },
            // {
            //   title: 'Access Management',
            //   route: 'account-access',
            // },
            // {
            //   title: 'My Company',
            //   route: 'account-company',
            // },
            // {
            //   title: 'My Account',
            //   route: 'account-user',
            // },
          ],
        },
        {
          title: 'CS Tools',
          route: 'cs-tools',
          icon: 'GlobeIcon',
        },
      ]

      const dataMember = [
        {
          title: 'Dashboard',
          route: 'dashboard',
          icon: 'LayersIcon',
        },
        {
          title: 'Campaign',
          icon: 'HashIcon',
          children: [
            {
              title: 'Manage Campaign',
              route: 'manage-campaign',
            },
            {
              title: 'Create Campaign',
              route: 'create-campaign',
            },
            // {
            //   title: 'Approve Campaign',
            //   route: 'approve-campaign',
            // },
          ],
        },
        {
          title: 'Report',
          route: 'report',
          icon: 'ActivityIcon',
        },
        // {
        //   title: 'Rate Card',
        //   route: 'rate-card',
        //   icon: 'GridIcon',
        // },
        // {
        //   title: 'Auction',
        //   icon: 'ClockIcon',
        //   children: [
        //     {
        //       title: 'Open Auction',
        //       route: 'open-auction',
        //     },
        //     {
        //       title: 'Auction Won',
        //       route: 'auction-won',
        //     },
        //     {
        //       title: 'History',
        //       route: 'history',
        //     },
        //   ],
        // },
        {
          title: 'Finance',
          icon: 'CreditCardIcon',
          children: [
            // {
            //   title: 'Invoice',
            //   route: 'invoice',
            // },
            {
              title: 'Topup Credit',
              route: 'topup-credit',
            },
          ],
        },
        // {
        //   title: 'Domain',
        //   route: 'domain',
        //   icon: 'GlobeIcon',
        // },
        // {
        //   title: 'Inbox',
        //   route: 'inbox',
        //   icon: 'InboxIcon',
        // },
        {
          title: 'Account',
          icon: 'UsersIcon',
          children: [
            // {
            //   title: 'New Partner Approval',
            //   route: 'account-approval',
            // },
            // {
            //   title: 'Partner Listings',
            //   route: 'account-partner',
            // },
            // {
            //   title: 'Access Management',
            //   route: 'account-access',
            // },
            {
              title: 'My Company',
              route: 'account-company',
            },
            {
              title: 'My Account',
              route: 'account-user',
            },
          ],
        },
      ]

      const dataApprover = [
        {
          title: 'Dashboard',
          route: 'dashboard',
          icon: 'LayersIcon',
        },
        {
          title: 'Campaign',
          icon: 'HashIcon',
          children: [
            {
              title: 'Manage Campaign',
              route: 'manage-campaign',
            },
            // {
            //   title: 'Create Campaign',
            //   route: 'create-campaign',
            // },
            // {
            //   title: 'Approve Campaign',
            //   route: 'approve-campaign',
            // },
          ],
        },
        {
          title: 'Report',
          route: 'report',
          icon: 'ActivityIcon',
        },
        // {
        //   title: 'Rate Card',
        //   route: 'rate-card',
        //   icon: 'GridIcon',
        // },
        // {
        //   title: 'Auction',
        //   icon: 'ClockIcon',
        //   children: [
        //     {
        //       title: 'Open Auction',
        //       route: 'open-auction',
        //     },
        //     {
        //       title: 'Auction Won',
        //       route: 'auction-won',
        //     },
        //     {
        //       title: 'History',
        //       route: 'history',
        //     },
        //   ],
        // },
        // {
        //   title: 'Finance',
        //   icon: 'CreditCardIcon',
        //   children: [
        //     // {
        //     //   title: 'Invoice',
        //     //   route: 'invoice',
        //     // },
        //     {
        //       title: 'Topup Credit',
        //       route: 'topup-credit',
        //     },
        //   ],
        // },
        // {
        //   title: 'Domain',
        //   route: 'domain',
        //   icon: 'GlobeIcon',
        // },
        // {
        //   title: 'Inbox',
        //   route: 'inbox',
        //   icon: 'InboxIcon',
        // },
        {
          title: 'Account',
          icon: 'UsersIcon',
          children: [
            {
              title: 'My Company',
              route: 'account-company',
            },
            {
              title: 'My Account',
              route: 'account-user',
            },
          ],
        },
      ]

      const dataAnalist = [
        {
          title: 'Dashboard',
          route: 'dashboard',
          icon: 'LayersIcon',
        },
        {
          title: 'Campaign',
          icon: 'HashIcon',
          children: [
            {
              title: 'Manage Campaign',
              route: 'manage-campaign',
            },
          ],
        },
        {
          title: 'Report',
          route: 'report',
          icon: 'ActivityIcon',
        },
        // {
        //   title: 'Auction',
        //   icon: 'ClockIcon',
        //   children: [
        //     {
        //       title: 'Open Auction',
        //       route: 'open-auction',
        //     },
        //     {
        //       title: 'Auction Won',
        //       route: 'auction-won',
        //     },
        //     {
        //       title: 'History',
        //       route: 'history',
        //     },
        //   ],
        // },
        // {
        //   title: 'Finance',
        //   icon: 'CreditCardIcon',
        //   children: [
        //     // {
        //     //   title: 'Invoice',
        //     //   route: 'invoice',
        //     // },
        //     {
        //       title: 'Topup Credit',
        //       route: 'topup-credit',
        //     },
        //   ],
        // },
        // {
        //   title: 'Domain',
        //   route: 'domain',
        //   icon: 'GlobeIcon',
        // },
        // {
        //   title: 'Inbox',
        //   route: 'inbox',
        //   icon: 'InboxIcon',
        // },
        {
          title: 'Account',
          icon: 'UsersIcon',
          children: [
            {
              title: 'My Company',
              route: 'account-company',
            },
            {
              title: 'My Account',
              route: 'account-user',
            },
          ],
        },
      ]
      // eslint-disable-next-line no-nested-ternary
      const data = (rootState.auth.userData.data.role === 'Telco' && rootState.auth.userData.data.company.internal_company === '0') ? dataTelco : ((rootState.auth.userData.data.company.internal_company === '2') ? dataApprover : ((rootState.auth.userData.data.company.internal_company === '3') ? dataAnalist : dataMember))
      commit('setNavigationMenu', data)
    },
    navigationMenu({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('/menu', { headers })
          .then(response => {
            const newData = response.data.data
            // console.log(newData)
            commit('setNavigationMenu', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
  modules: {},
}
